import cn from 'classnames';
import * as Account from './components/Account/Account.css';
import * as SearchForm from './components/SearchForm/SearchForm.css';
import * as Results from './components/Results/Results.css';
import * as SeatMap from './components/SeatMap/SeatMap.css';
import * as Counter from './components/Counter/Counter.css';
import * as Button from './components/Button/Button.css';
import * as Tabs from './components/Tabs/Tabs.css';
import * as Baggage from './components/Baggage/Baggage.css';
import * as Meal from './components/Meal/Meal.css';
import * as Stepbar from './components/Stepbar/Stepbar.css';
import * as FareGroup from './components/FareGroup/FareGroup.css';
import * as FlightInfo from './components/FlightInfo/FlightInfo.css';
import * as Checkout from './components/Checkout/Checkout.css';
import * as CheckoutAdditionalService from './components/CheckoutAdditionalService/CheckoutAdditionalService.css';
import * as MealService from './components/CheckoutAdditionalService/components/Meal/Meal.css';
import * as SeatsService from './components/CheckoutAdditionalService/components/Seats/Seats.css';
import * as BaggageService from './components/CheckoutAdditionalService/components/Baggage/Baggage.css';
import * as AeroexpressService from './components/CheckoutAdditionalService/components/Aeroexpress/Aeroexpress.css';
import * as BusinessService from './components/CheckoutAdditionalService/components/Business/Business.css';
import * as CapsuleHotelService from './components/CheckoutAdditionalService/components/CapsuleHotel/CapsuleHotel.css';
import * as InsuranceService from './components/CheckoutAdditionalService/components/Insurance/Insurance.css';
import * as LoyaltyService from './components/CheckoutAdditionalService/components/Loyalty/Loyalty.css';
import * as PriorityBoardingService from './components/CheckoutAdditionalService/components/PriorityBoarding/PriorityBoarding.css';
import * as Passengers from './components/Passengers/Passengers.css';
import * as Banner from './components/AdditionalServiceBanner/AdditionalServiceBanner.css';
import * as Promo from './components/PromoLoader/PromoLoader.css';
import * as Checkin from './components/Checkin/Checkin.css';
import * as QuickSearchForm from './components/QuickSearchForm/QuickSearchForm.css';
import * as MobileFlight from './components/MobileFlight/MobileFlight.css';
import * as MobileSummaryFlight from './components/MobileSummaryFlight/MobileSummaryFlight.css';
import * as MobileSelectedFare from './components/MobileSelectedFare/MobileSelectedFare.css';
import * as MobileStepbar from './components/MobileStepbar/MobileStepbar.css';
import * as MobileToolbar from './components/MobileToolbar/MobileToolbar.css';
import * as PriceGraph from './components/PriceGraph/PriceGraph.css';
import * as Modal from './components/Modal/Modal.css';
import * as Toolbar from './components/Toolbar/Toolbar.css';
import * as ResendTicketsForm from './components/ResendTicketsForm/ResendTicketsForm.css';
import * as Refund from './components/Refund/Refund.css';
import * as Exchange from './components/Exchange/Exchange.css';
import FareConditions from './components/FareConditions/FareConditions.css';
import BaggageCard from './components/BaggageCard/BaggageCard.css';
import ReasonForm from './components/Refund/ReasonForm/ReasonForm.css';
import ScheduleFormLocation from './components/ScheduleForm/Location/Location.css';
import ScheduleFormValue from './components/ScheduleForm/Value/Value.css';
import CoreScheduleLocation from './components/CoreSchedule/Location/Location.css';
import ScheduleFlight from './components/CoreSchedule/ScheduleFlight/ScheduleFlight.css';
import WeekDays from './components/CoreSchedule/WeekDays/WeekDays.css';
import DateSwitcher from './components/CoreSchedule/DateSwitcher/DateSwitcher.css';
import Weekpicker from './components/CoreSchedule/Weekpicker/Weekpicker.css';
import SpecialEquipment from './components/SpecialEquipment/SpecialEquipment.css';
import ResultsError from './components/ResultsError/ResultsError.css';
import AdditionalBaggage from './components/AdditionalBaggage/AdditionalBaggage.css';
import Aeroexpress from './components/Aeroexpress/Aeroexpress.css';
import AddBooking from './components/AddBooking/AddBooking.css';
import BaggageDialogHeader from './components/UpgradeBaggageDialog/BaggageDialogHeader/BaggageDialogHeader.css';
import Accompanying from './components/PassengerForm/components/components/FormFields/Group/Accompanying/Accompanying.css';
import AeroexpressPassenger from './components/CheckoutAdditionalService/components/AeroexpressPassenger/AeroexpressPassenger';
import BaggageIcon from './components/Baggage/Baggage/components/BaggageIcon/BaggageIcon.css';
import PaymentResult from './components/PaymentResult/PaymentResult.css';
import UpgradeBaggageDialog from './components/UpgradeBaggageDialog/UpgradeBaggageDialog.css';
import Group from './components/PassengerForm/components/components/FormFields/Group/Group.css';
import AircraftPopup from './components/AircraftPopup/AircraftPopup.css';
import InfoMessages from './components/InfoMessages/InfoMessages.css';
import TicketExample from './components/TicketExample/TicketExample.css';
import Disabilities from './components/Disabilities/Disabilities.css';
import InsuranceSelectForm from './components/InsuranceSelectForm/InsuranceSelectForm.css';
import InsuranceOptionsList from './components/InsuranceOptionsList/InsuranceOptionsList.css';
var theme = {
    Link: {
        Link: {
            link: Checkout.link
        }
    },
    Input: {
        Input: {
            hint_error: Passengers.hint_error
        }
    },
    Autocomplete: {
        Autocomplete: {
            inner_input: Passengers.autocompleteInner_input,
            autocomplete__root: Passengers.autocomplete__root,
            focused: Passengers.focused,
            label_error: Passengers.label_error,
            label_shrink: Passengers.label_shrink,
            input_focused: Passengers.focused,
            input: Passengers.input,
            options: SearchForm.options,
            option: Passengers.autocomplete_option
        }
    },
    Datepicker: {
        MonthHeaderStyles: {
            monthHeader: SearchForm.datepicker__monthHeader
        },
        DayStyles: {
            day__inside: SearchForm.day__inside,
            day_selected: SearchForm.selected,
            day_weekend: SearchForm.weekend,
            day_inPeriod: SearchForm.inPeriod,
            day_endPeriod: SearchForm.endPeriod,
            day_startPeriod: SearchForm.startPeriod,
            day: SearchForm.day,
            day_today: SearchForm.today,
            day_notAvailable: SearchForm.notAvailable
        },
        MonthsWrapperStyles: {
            wrapper: SearchForm.monthWrapper
        }
    },
    SearchFormDatepicker: {
        SearchFormDatepickerStyles: {
            content: SearchForm.datepicker__content,
            progress__color: SearchForm.datepicker__progress,
            inputWrapper: SearchForm.datepicker__inputWrapper,
            popup: SearchForm.datepicker__popup,
            footer: SearchForm.datepicker__footer,
            datepicker__disclaimer: SearchForm.datepicker__disclaimer,
            dialog__activeDate: SearchForm.dialog__activeDate
        },
        DayStyles: {
            day_hasPrice: SearchForm.hasPrice,
            day_selected: SearchForm.selected,
            day__price: SearchForm.day__price,
            day_withPrice: SearchForm.withPrice
        }
    },
    LocationAutocomplete: {
        DirectionsDialog: {
            paper: SearchForm.directionsDialog__paper
        },
        Dropdown: {
            options: SearchForm.optionsDrop
        },
        Option: {
            meta_gray: SearchForm.locationAutocompleteOption__metaGray
        }
    },
    Contacts: {
        ContactsStyles: {
            contacts: Passengers.contacts__container,
            short: Passengers.contacts__short,
            form: Passengers.contacts__form,
            description__text: Passengers.contacts__description,
            fields: Passengers.contacts__fields,
            field: Passengers.contacts__field,
            footer: Passengers.contacts__footer,
            footer__social: Passengers.footer__social,
            footer__inner: Passengers.footer__inner,
            customer__info: Passengers.contacts_customerInfo,
            header: Passengers.contacts__header,
            description__header: Passengers.contacts__descriptionHeader
        }
    },
    SearchForm: {
        Bottom: {
            bottom: SearchForm.bottom
        },
        OfferHotels: {
            switchItem: SearchForm.offerHotel__switch,
            toggle_active: SearchForm.offerHotel__switch_active
        },
        Datepicker: {
            highlightedDate_lite: SearchForm.highlightedDate_lite,
            alternative_dow: SearchForm.datepicker__dow,
            highlightedDate_withPrice: SearchForm.withPrice,
            dates: SearchForm.datepicker__dates,
            placeholder: SearchForm.datepicker__placeholder,
            dates_focused: SearchForm.focused,
            returnDelete: SearchForm.clear,
            dates__to: SearchForm.datepicker__dates_to,
            dates__back: SearchForm.datepicker__dates_back,
            dates__to_focused: SearchForm.focused,
            dates__back_focused: SearchForm.focused,
            date__inputWrapper: SearchForm.date__inputWrapper
        },
        Passengers: {
            arrowIcon: SearchForm.passengers__arrow,
            title: SearchForm.passengers__title,
            passengers: SearchForm.passengers,
            selector_focused: SearchForm.focused,
            selector: SearchForm.passengers__trigger,
            passengers_isMultiCity: SearchForm.passengers__isMultyCity
        },
        StartSearch: {
            startSearch: SearchForm.startSearch,
            startSearch_multiCity: SearchForm.startSearch__multyCity
        },
        Value: {
            placeholder: SearchForm.value__placeholder,
            wrapper: SearchForm.value__wrapper,
            wrapper_focused: SearchForm.focused,
            code: SearchForm.value__code,
            value: cn(SearchForm.value, SearchForm.value__value),
            withMultiCity: SearchForm.value__withMultiCity
        },
        Controls: {
            controls: SearchForm.controls,
            controls_multiCity: SearchForm.controls__controlsMultyCity
        },
        Segments: {
            segments: SearchForm.segments,
            segments_multiCity: SearchForm.segments__multiCity
        },
        SearchForm: {
            searchForm: SearchForm.searchForm
        },
        Segment: {
            input_focused: SearchForm.focused,
            wrapper: SearchForm.segmentWrapper,
            cell: SearchForm.segmentCell,
            cell_date: SearchForm.segmentCell_date,
            input: SearchForm.segmentInput,
            segment: SearchForm.segment__segment,
            remover: SearchForm.segment__remover,
            withMultiCity: SearchForm.segment__withMultiCity,
            cell_location: SearchForm.segment__cellLocation
        },
        Location: {
            switcher: SearchForm.switcher,
            switcher_alternative: SearchForm.switcher_alternative,
            switcher_highlighted: SearchForm.active,
            input: SearchForm.location__input,
            input_withoutPlaceholder: SearchForm.withoutPlaceholder
        },
        Actions: {
            actions: SearchForm.actions__container,
            addSegment: SearchForm.actions__addSegment,
            removeSegment: SearchForm.actions__removeSegment
        },
        MultiCity: {
            multiCity: SearchForm.multiCity__container,
            caption: SearchForm.multiCity__caption
        }
    },
    Passengers: {
        PassengerStyles: {
            age: SearchForm.passengers__age,
            info__icon: SearchForm.passengers__infoIcon,
            counter: SearchForm.passengers__counter,
            increase: SearchForm.passengers__increase,
            decrease: SearchForm.passengers__decrease
        }
    },
    Results: {
        Results: {
            results: Results.result,
            share: Results.share,
            messages: Results.messages,
            messages_item: Results.messages_item
        },
        SelectedFares: {
            price: Results.result__price
        },
        Calendar: {
            legNumber: Results.calendarNumber,
            title__text: Results.calendarTitleText,
            diagram: Results.calendarDiagramButton
        },
        Sortings: {
            currentSorting: Results.currentSorting,
            mobile: Results.sorting_mobile,
            mobile__list: Results.sorting_mobileList,
            mobile__list__close: Results.sorting_mobileListClose,
            mobile__list__title: Results.sorting_mobileListTitle,
            mobile__list__button: Results.sorting_mobileListButton,
            mobile__list__item: Results.sorting_mobileListItem,
            mobile__list__button_inactive: Results.sorting_mobileListButtonInactive,
            mobile__actions: Results.sorting_mobileActions,
            flightType: Results.sorting__flightType,
            title: Results.sorting__title
        },
        FlightsList: {
            controls__wrapper: Results.flightsControls
        }
    },
    WeekCalendar: {
        WeekCalendarStyles: {
            container: Results.calendarWeekContainer,
            dayWrapper: Results.calendarWeekDay
        },
        DayStyles: {
            day: Results.calendarDay,
            day_selected: Results.calendarDaySelected,
            day_best: Results.calendarDayBest,
            day_notAvailable: Results.calendarDayNotAvailable,
            date: Results.calendarDayDate,
            date__info: Results.calendarDayInfo,
            price: Results.calendarDayPrice
        },
        SliderStyles: {
            container: Results.calendarSliderContainer,
            slider: Results.calendarSlider,
            arrow_next: cn(Results.calendarSliderArrowNext, Exchange.calendarArrow_next),
            arrow_prev: Results.calendarSliderArrowPrev
        }
    },
    Amenities: {
        Amenities: {
            amenities__item: Results.resultAmenitiesItem,
            amenities__item_unavailable: Results.resultAmenitiesItemUn,
            amenities: FlightInfo.flightInfo__amenities
        }
    },
    DesktopFlightRoute: {
        FlightPriceStyles: {
            best: Results.resultFlightPriceBest,
            selectFrom_best: Results.resultFlightPriceSelectBest,
            price__money: Results.resultFlightPriceMoney,
            price_single: Results.resultFlightPriceSingle,
            button: Results.resultFlightPriceButton,
            fare_family: Results.resultFlightPriceFareFamily,
            subsidies: Results.resultSubsidized
        },
        SingleFlightSegment: {
            container: Results.resultSingleFlightContainer,
            route: Results.resultSingleFlightRoute,
            flightNumber: Results.resultSingleFlightNumber,
            info: Results.resultSingleFlightInfo,
            info__aircraft: Results.resultSingleFlightInfoAircraft
        },
        RouteArrowStyles: {
            route: Results.resultRouteArrowContainer,
            timeInRoute: Results.resultRouteArrowTime,
            container: Results.routeArrowContainer
        },
        PointStyles: {
            point: Results.resultPoint,
            date__container: Results.resultPointDateContainer,
            time: Results.resultPointTime,
            date: Results.resultPointDate,
            point_arrival: Results.resultPointArrival,
            stop: Results.resultPointStop,
            airport__iata: Results.resultPointAirportIata,
            airport__city: Results.resultPointAirportCity,
            airport__name: Results.resultPointAirportName,
            airport: Results.resultAirport
        },
        DesktopFlightRouteStyles: {
            flight: Results.resultRouteFlight
        },
        StopsInfoStyles: {
            stop__label: Results.resultStopLabel
        },
        SegmentStyles: {
            flightInfo__icon: Results.resultFlightInfoIcon,
            flightInfo__date: Results.resultFlightInfoDate,
            flightInfo__nextDay: Results.resultFlightInfoNext,
            flightInfo__airline: Results.segment__flightInfoAirline,
            planeInfo: Results.resultPlaneInfo,
            aircraft: Results.aircraft,
            amenities: Results.amenities
        }
    },
    MobileSegmentInfo: {
        MobileSegmentFlat: {
            row: Results.resultFlatRow,
            duration__wrapper: Results.resultFlatDuration__wrapper,
            time: Results.resultFlatTime,
            city: Results.resultFlatCity,
            flightNumber__route: Results.resultFlatFlightNumber,
            duration__text: Results.resultFlatDuration,
            aircraftName: Results.resultFlatFlight__aircraftName,
            flightNumber: Results.resultFlatFlight,
            transfer: Results.resultFlatTransfer,
            segment: Results.resultSegment
        }
    },
    SeatMap: {
        AirplaneStyles: {
            segment: SeatMap.airplaneSegment,
            airplane__name: SeatMap.airplaneName,
            seatsDetails: SeatMap.airplaneSeatsDetails
        },
        AirplaneInfoStyles: {
            sunInfo: SeatMap.AirplaneInfoSubInfo
        },
        Controls: {
            button: SeatMap.controlsButton
        },
        Passenger: {
            item: SeatMap.passengerItem,
            item_active: SeatMap.passengerItemActive,
            avatar: SeatMap.passengerAvatar,
            passengerName: SeatMap.passengerName,
            payload: SeatMap.passengerPayload,
            money: SeatMap.passengerMoney,
            select: SeatMap.passengerSelect,
            item_recommend: SeatMap.passengerRecommend
        },
        PassengersStyles: {
            recommend__wrapper: SeatMap.passengersWrapper,
            recommend: SeatMap.passengersRecommend,
            passengers__button: SeatMap.passengersButton,
            passengers__button_clear: SeatMap.passengersButtonClear,
            disclaimer: SeatMap.passengers__disclaimer
        },
        ComponentStyles: {
            map: SeatMap.map,
            header_mobile: SeatMap.componentHeaderMobile
            // map: SeatMap.componentMap
        },
        SeatTooltipStyles: {
            tooltip: SeatMap.seatTooltip,
            info: SeatMap.seatTooltipInfo,
            tooltip_withInfo: SeatMap.seatTooltipWithInfo,
            tooltip_recommend: SeatMap.seatTooltipRecommend
        },
        SeatsInfoStyles: {
            price__wrapper: SeatMap.seatInfoPriceWrap,
            title: SeatMap.seatsInfo__title,
            classType: SeatMap.seatsInfo__classType,
            features: SeatMap.seatsInfo__features,
            seat__info: SeatMap.seatsInfo__seat__info,
            price: SeatMap.seatsInfo__price
        },
        SeatStyles: {
            seat: SeatMap.seat,
            seat_standart: SeatMap.seatStandart,
            number: SeatMap.seatNumber,
            seat_occupied: SeatMap.seatOccupied,
            seat_recommend: SeatMap.seatRecommend,
            seat_recommendCurrent: SeatMap.seatRecommendCurrent
        },
        SeatMapStyles: {
            row__serviceHeader: SeatMap.seatMapHeaderBottom,
            row__serviceHeader__wrapper: SeatMap.seatMapHeader,
            row__serviceHeader_comfort: SeatMap.seatMapHeaderComfort,
            row__serviceHeader_preferred: SeatMap.seatMapHeaderPreferred
        },
        SeatServiceSlide: {
            single: Checkin.seatServiceSlide_single,
            single_cancel: Checkin.seatServiceSlide_single_cancel
        },
        SeatsRecommendPopup: {
            slide: SeatMap.seatRecommendSlide,
            content: SeatMap.seatRecommendContent,
            price__wrapper: SeatMap.seatRecommendPrice,
            money: SeatMap.seatRecommendMoney,
            confirm: SeatMap.seatRecommendConfirm
        },
        SeatMapDisclaimerStyles: {
            disclaimer: SeatMap.seatMap__disclaimer
        }
    },
    Disclaimer: {
        DisclaimerStyles: {
            disclaimer__icon: cn(SeatMap.disclaimer__icon)
        }
    },
    Counter: {
        Counter: {
            counter: Counter.counterWrap,
            button: Counter.counterButton,
            button_disabled: Counter.counterButtonDisabled,
            value: Counter.counterValue,
            value_zero: Counter.counterZero
        }
    },
    Button: {
        Button: {
            button: Button.button,
            loader: Button.button_loader
        },
        ActionButton: {
            button: Button.actionButton
        },
        WhiteButton: {
            button: Button.whiteButton
        }
    },
    SuggestionModalContent: {
        SuggestionModalContent: {
            modal__button: Button.modalButton,
            modal__button_decline: Button.modalButton_decline
        }
    },
    Toolbar: {
        Toolbar: {
            price: Checkout.toolbarPrice,
            button: Button.toolbarButton,
            button_disabled: Button.toolbarDisabledButton,
            backButton: Button.toolbarBackButton,
            actions_left: Checkout.toolbarActions_left,
            actions: Toolbar.actions
        }
    },
    ServiceRecommendation: {
        Base: {
            button: Button.baseButton,
            button_cancel: Button.baseButtonCancel
        },
        Meal: {
            title: Meal.mealBase__title,
            price: Meal.mealBase__price,
            price__money: Meal.mealBase__priceMoney
        }
    },
    QuickSearchForm: {
        QuickSearchForm: {
            wrapper: Tabs.tabsSearch,
            form: QuickSearchForm.quickSearchForm
        },
        Summary: {
            route: Tabs.tabsSearch__route,
            passengers: Tabs.tabsSearch__passengers,
            trigger: Tabs.tabsSearch__trigger,
            trigger__arrow: Tabs.tabsSearch__triggerArrow
        }
    },
    SegmentTabs: {
        SegmentTabs: {
            wrapper: Tabs.tabs,
            title: Tabs.tabs__title,
            segments: Tabs.tabs__segments,
            close: Tabs.tabs__close
        },
        SegmentTab: {
            segment: Tabs.tabs__segment,
            segment_active: Tabs.tabs__segment_active
        }
    },
    BaggageService: {
        BaggageServiceStyles: {
            baggage: Baggage.baggage,
            content: Baggage.content,
            additional: Baggage.additional,
            baggage__icon_notSelected: Baggage.baggage__icon_notSelected,
            baggage_full: Baggage.baggage_full,
            baggage_selected: Baggage.baggage_selected,
            baggage_included: Baggage.baggage_included,
            services: Baggage.services,
            services__switcher: Baggage.services__switcher,
            service: Baggage.service,
            services__main: Baggage.services__main,
            service__name: Baggage.service__name,
            service__sizes: Baggage.service__sizes,
            service__values: Baggage.service__values,
            service__price: Baggage.service__price,
            service__counter: Baggage.service__counter,
            notSelected: Baggage.notSelected,
            carryon: Baggage.carryon,
            header__passenger: Baggage.servicesPassenger,
            header__price: Baggage.servicesPrice,
            checkbox: Baggage.checkbox,
            checkbox_notActive: Baggage.checkbox_notActive,
            checkbox_active: Baggage.checkbox_active,
            value_highlighted: Baggage.value_highlighted,
            segment: Baggage.segment,
            segment__value: Baggage.segment__value,
            segment__value_readonly: Baggage.segment__value_readonly,
            segment__direction: Baggage.segment__direction,
            slide__header__checkbox_active: Baggage.baggageService_slideActive,
            slide__options__item__price: Baggage.baggageService_slideOptionItemPrice,
            checkbox_checked: Baggage.baggageService_checkboxChecked,
            add__button: Baggage.baggageService_addButton
        },
        AdditionalStyles: {
            wrapper: Baggage.additionalWrapper,
            header: Baggage.additionalHeader,
            not_selected: Baggage.additionalNotSelected,
            checkbox: Baggage.additionalCheckbox,
            checkbox_checked: Baggage.additionalCheckboxChecked,
            switcher: Baggage.additionalSwitcher,
            checkbox_notActive: Baggage.additionalCheckbox_notActive,
            checkbox_root: Baggage.additionalStyles_checkboxRoot
        }
    },
    Service: {
        DialogStyles: {
            dialog__content: cn(Meal.dialog__content)
        }
    },
    MealService: {
        CategoriesStyles: {
            wrapper: Meal.categoriesWrapper,
            category__button: Meal.categoriesButton
        },
        List: {
            item: Meal.mealList__item,
            item_selected: Meal.mealList__item_selected,
            item__icon: Meal.mealList__icon
        },
        ServiceWrapper: {
            meals: Meal.serviceWrapper__meals
        }
    },
    Meal: {
        Meal: {
            meal: Meal.mealItem,
            image: Meal.mealItem__image,
            name: Meal.mealItem__name,
            price: Meal.mealItem__price,
            count: Meal.mealItem__count,
            weight: Meal.mealItem__weight,
            meal_fullSize: Meal.mealItem_fullSize
        },
        Details: {
            image: Meal.mealDetail__image,
            selector: Meal.mealDetail__selector,
            passenger: Meal.mealDetail__passenger,
            passenger__index: Meal.mealDetail__index,
            name: Meal.mealDetail__name,
            weight: Meal.mealDetail__weight,
            trigger: Meal.mealDetail__trigger,
            clear: Meal.mealDetail__clear,
            addForAll: Meal.mealDetail__addForAll
        }
    },
    Stepbar: {
        Stepbar: {
            stepbar: Stepbar.stepSection,
            cart: Stepbar.cart
        },
        Step: {
            id: Stepbar.stepId,
            step: Stepbar.stepItem,
            step_passed: Stepbar.stepItem_passed,
            step_active: Stepbar.stepItem_active,
            step_clickable: Stepbar.stepItem_clickable
        }
    },
    DesktopFlight: {
        ModalContent: {
            header_title: FareGroup.desktopFlightModal_headerTitle,
            header_arrow: FareGroup.desktopFlightModal_headerArrow,
            fareGroup__button: FareGroup.fareTab__item,
            fareGroup__button_active: FareGroup.fareTab__item_active,
            compareFaresLink: FareGroup.fareCompareLink,
            stubOptions: FareGroup.fareTab__stubOptions,
            fareGroup_stub: FareGroup.desktopFlightModal_stub,
            paper: FareGroup.desktopFlightModal_paper,
            compareFaresLink_icon: FareGroup.fareCompareLink_icon,
            scroll_up: FareGroup.desktopFlightModal_scrollUp,
            upsaleRightInfoMessage: FareGroup.desktopFlightModal_upsaleRightInfoMessage,
            infoMessage__htmlMessage: FareGroup.desktopFlightModal_infoMessageHtml
        },
        Location: {
            terminal: FareGroup.desktopFlightModal_locationTerminal,
            weather_temp: FareGroup.desktopFlightModal_locationWeatherTemp,
            date: FareGroup.desktopFlightModal_locationDate,
            date_icon: FareGroup.desktopFlightModal_locationDateIcon,
            time: FareGroup.desktopFlightModal_locationTime,
            time_iata: FareGroup.desktopFlightModal_locationTimeIata
        },
        DesktopFlightPopup: {
            paper: Results.desktopFlightPopup__paper,
            scrollBody: Results.desktopFlightPopup_scrollBody
        }
    },
    Insurance: {
        InsuranceStyles: {
            dialog__header: InsuranceService.insurance__dialogHeader
        },
        InsuranceCardStyles: {
            insurance__button: InsuranceService.insuranceCard__button,
            insurance__button_selected: InsuranceService.insuranceCard__button_selected,
            insurance__money: InsuranceService.insuranceCard__money
        }
    },
    FareGroup: {
        FareGroup: {
            fareGroup: FareGroup.fareItem,
            fareGroup_Business: FareGroup.fareItem_business,
            fareGroup_Economy: FareGroup.fareItem_economy,
            fareGroup_white: FareGroup.fareItem_white,
            button: FareGroup.fareItem__button,
            price: FareGroup.fareItem__price,
            option__title: FareGroup.fareItem__optionTitle,
            option__value: FareGroup.fareItem__optionValue,
            option_unavailable: FareGroup.fareItem__optionUnavailable,
            option_free: FareGroup.fareItem__optionFree,
            option: FareGroup.fareItem__optionItem
        },
        FareGroupGrid: {
            header: FareGroup.fareItem__header,
            option: FareGroup.fareItem__optionGrid,
            paid: FareGroup.fareItem__paid,
            icon: FareGroup.fareItem__icon,
            availabilityIcon: FareGroup.fareItem__availabilityIcon,
            upgradeOffer__link: FareGroup.fareItem__upgradeOffer,
            upgradeOffer: FareGroup.fareItem__upgradeWrapper
        },
        RecommendedBadge: {
            badge: Results.recommendedBadge
        }
    },
    AdditionalServiceBanner: {
        AdditionalServiceBannerStyles: {
            baggageBanner: Banner.banner
        }
    },
    BaggagePage: {
        BaggagePage: {
            baggage: Checkout.baggagePage
        }
    },
    CompareFares: {
        CompareFares: {
            container: FareGroup.fareCompare__container,
            compareFares: FareGroup.fareCompare,
            fareHeadingItem: FareGroup.fareCompare__header,
            fareHeadingItem_isKey: FareGroup.fareCompare__header_isKey,
            groupTitle: FareGroup.fareCompare__groupTitle,
            title: FareGroup.fareCompare__title,
            link: FareGroup.fareCompare__link,
            tableRow: FareGroup.fareCompare__tableRow,
            tableRow_fullDescr: FareGroup.fareCompare__tableRowFull,
            cell: FareGroup.fareCompare__cell,
            image: FareGroup.image,
            headingWrp: FareGroup.headingWrp,
            modal__heading: FareGroup.modal__heading,
            slider: FareGroup.fareCompare__slider
        }
    },
    FlightInfo: {
        FlightInfo: {
            segment__location: FlightInfo.flightInfo__segment
        }
    },
    FlightCard: {
        FlightCard: {
            airline: FlightInfo.flightInfo__airline,
            airline__number: FlightInfo.flightInfo__airlineNumber,
            airline__logo: FlightInfo.flightInfo__airlineLogo,
            aircraft__name_active: FlightInfo.flightInfo__aircraftName_active,
            footer: FlightInfo.flightInfo__footer,
            info: FlightInfo.flightInfo__info,
            flight__block: FlightInfo.flightInfo__flightBlock,
            flight__title: FlightInfo.flightInfo__flightTitle,
            flight__value: FlightInfo.flightInfo__flightValue
        }
    },
    Passenger: {
        Select: {
            option: Passengers.selectOption,
            icon: Passengers.selectIcon,
            helperText: Passengers.helperText
        },
        Switch: {
            element: Passengers.switch,
            element_active: Passengers.active,
            error: Passengers.switch_error
        },
        PassengerStyles: {
            form_citizenship: Passengers.citizenship,
            form: Passengers.passengerForm,
            form_identy: Passengers.identity,
            form_loyalty: Passengers.loyalty,
            form__field: Passengers.passengerForm__field,
            header__services: Passengers.header__services,
            header_notInteractive: Passengers.passenger__notInteractive,
            form__field_birthday: Passengers.passenger_formFieldBirthday,
            form__field_gender: Passengers.passenger_formFieldGender
        }
    },
    Checkout: {
        PassengersToolbar: {
            label: Passengers.label,
            checkbox_checked: Passengers.checkbox_checked,
            checkbox: Passengers.checkbox
        },
        CheckoutStyles: {
            checkout: Passengers.checkout,
            checkoutServices: Passengers.checkoutServices,
            container: cn(Checkout.container, Passengers.checkoutContainer),
            flight: Passengers.desktopSummaryFlight,
            paidOrderWrapper: Passengers.checkout_painOrderWrapper,
            orderControlBtn: Checkout.orderControlButton,
            summary: Checkout.checkout_summary,
            form__passenger: Passengers.checkout__formPassengers,
            messages_item: Passengers.messages_item,
            summary__wrp: Passengers.summary__wrp,
            messages: Passengers.messages
        },
        PassengersStyles: {
            passengers: Passengers.passengersSection
        },
        ThanksBanner: {
            wrapper: Passengers.thanksBanner_wrapper,
            resendButton: Passengers.thanksBanner_resendButton,
            doneIcon: Passengers.thanksBanner_doneIcon
        },
        Consents: {
            consents__text: Passengers.consents__text
        }
    },
    InfoLinksLabel: {
        InfoLinksLabel: {
            wrapper: Checkout.linksWrapper
        }
    },
    InfoMessages: {
        InfoMessages: {
            notifications: InfoMessages.notifications
        }
    },
    CheckoutAdditionalService: {
        CheckoutAdditionalService: {
            content: CheckoutAdditionalService.content,
            service: CheckoutAdditionalService.checkoutService,
            service_active: CheckoutAdditionalService.checkoutService_active,
            header: CheckoutAdditionalService.checkoutService__header,
            header__text: CheckoutAdditionalService.checkoutService__headerText,
            header__price: CheckoutAdditionalService.checkoutService__headerPrice,
            icon: CheckoutAdditionalService.checkoutService__headerIcon,
            main: CheckoutAdditionalService.checkoutService__main,
            buttons: CheckoutAdditionalService.checkoutService__buttons,
            add: CheckoutAdditionalService.checkoutService__add
        },
        CheckoutAdditionalServiceBaggage: {
            baggage: BaggageService.baggage,
            baggage__item: BaggageService.baggageItem
        },
        CheckoutAdditionalServiceMeal: {
            meal: MealService.meal
        },
        Seats: {
            seats: SeatsService.seats
        },
        Aeroexpress: {
            aeroexpress: AeroexpressService.aeroexpress
        },
        AeroexpressPassenger: {
            control: AeroexpressPassenger.control
        },
        Business: {
            business: BusinessService.business
        },
        CapsuleHotel: {
            capsuleHotel: CapsuleHotelService.capsuleHotel
        },
        Loyalty: {
            loyalty: LoyaltyService.loyalty
        },
        PriorityBoarding: {
            priority: PriorityBoardingService.priority
        }
    },
    Aeroexpress: {
        Aeroexpress: {
            modal: Aeroexpress.modal
        },
        ModalContent: {
            modal__title: Aeroexpress.modal__title,
            modal__price: Aeroexpress.modal__price,
            heading: Aeroexpress.heading,
            heading_date: Aeroexpress.heading_date,
            heading_city: Aeroexpress.heading_city,
            heading_route_part: Aeroexpress.heading_route_part,
            button_remove: Aeroexpress.button_remove,
            select__wrp: Aeroexpress.select__wrp
        }
    },
    OrderCard: {
        OrderStatus: {
            root: Checkout.orderStatus__root,
            type_account: Checkout.orderStatus__typeAccount,
            type_review: Checkout.orderStatus__type_review,
            wait_payment: Checkout.orderStatus__wait_payment,
            transactions: Account.orderStatus_transactions,
            confirmed: Checkout.orderStatus__confirmed,
            text: Checkout.orderStatus_text,
            icon: Checkout.orderStatus_icon,
            content: Checkout.orderStatus_content
        },
        OrderPassengers: {
            root: Checkout.orderPassengers_root,
            icon: Checkout.orderPassengers__icon,
            control: Checkout.orderPassengers__control
        },
        OrderBooking: {
            root: Checkout.orderBooking__root,
            type_review: Checkout.orderBooking__type_review,
            type_account: Checkout.orderBooking__typeAccount,
            download_wrapper: Account.orderBooking_downloadWrapper
        },
        OrderCard: {
            root: Account.orderCard_root,
            type_review: Account.orderCard_typeReview,
            status: Account.orderCard_status,
            booking: Account.orderCard_booking,
            type_account: cn(Account.orderCard_typeAccount, Checkout.orderCard_typeAccount),
            passengers: Account.orderCard_passengers,
            controls: Account.orderCard_controls
        },
        OrderTickets: {
            wrapper: Account.orderTickets_wrapper,
            text: Account.orderTickets_text,
            link: Account.orderTickets_link
        },
        OrderCardControls: {
            button: Checkout.orderControlButton
        },
        OrderPreview: {
            root: cn(Account.orderPreview_root, Checkout.orderPreview__root),
            overlay: Checkout.orderPreview__overlay
        }
    },
    MobileAuthForm: {
        MobileAuthForm: {
            social: Checkout.mobileAuthForm__social
        }
    },
    PromoLoader: {
        PromoLoader: {
            wrapper: Promo.promoWrapper,
            progress__bar__color: Promo.promoProgressColor,
            promo__image: Promo.promoImage,
            promo__content: Promo.promoContent,
            text: Promo.promoText,
            loader__wrp: Promo.promoLoader
        }
    },
    MobileFlight: {
        FlightStyles: {
            flight: MobileFlight.flightSm,
            flight_withAircraft: MobileFlight.flightSm_aircraft,
            price: MobileFlight.flightSm__price,
            price__money: MobileFlight.flightSm__priceMoney
        }
    },
    MobileSummaryFlight: {
        MobileSummaryFlight: {
            wrapper: MobileSummaryFlight.mobileSummaryFlight__wrapper,
            footer: MobileSummaryFlight.mobileSummaryFlight__footer,
            footer__price_flat: MobileSummaryFlight.mobileSummaryFlight__price
        }
    },
    FareConditions: {
        FareConditions: {
            paperRoot: FareConditions.paperRoot,
            header: FareConditions.header,
            heading: FareConditions.heading,
            tabsWrp: FareConditions.tabsWrp,
            tab: FareConditions.tab,
            tabIndicator: FareConditions.tabIndicator,
            tab_active: FareConditions.tab_active,
            segmentTabs: FareConditions.segmentTabs,
            fareConditionsSegmentHeading__inner: FareConditions.fareConditionsSegmentHeading__inner,
            fareConditionsSegmentFareCode: FareConditions.fareConditionsSegmentFareCode,
            fareConditionsContent: FareConditions.fareConditionsContent,
            fareConditionsSegmentHeading: Results.fareConditionsSegmentHeading,
            segmentTabsTab: FareConditions.segmentTabsTab,
            segmentTabsTab__active: FareConditions.segmentTabsTab__active,
            segmentTabsSegments: FareConditions.segmentTabsSegments
        }
    },
    SelectedFare: {
        SelectedFare: {
            link: Results.selectedFare__link
        }
    },
    MobileSelectedFare: {
        MobileSelectedFareStyles: {
            dialog__header: MobileSelectedFare.dialog__header,
            selectedFare: MobileSelectedFare.mobileSelectedFare,
            feature__icon: MobileSelectedFare.mobileSelectedFare__icon,
            features__info: MobileSelectedFare.mobileSelectedFare__info
        }
    },
    FareLock: {
        SwitchBlock: {
            root: MobileSelectedFare.mobileFareLock
        }
    },
    MobileStepbar: {
        MobileStepbarStyles: {
            stepbar: MobileStepbar.mobileStepbar,
            header: MobileStepbar.mobileStepbar__header,
            price: MobileStepbar.mobileStepbar__price,
            expand: MobileStepbar.mobileStepbar__expand
        },
        StepStyles: {
            step: MobileStepbar.mobileStep,
            step__price: MobileStepbar.mobileStep__price,
            price__expand: MobileStepbar.mobileStep__priceExpand,
            name__label: MobileStepbar.mobileStep__label,
            name__index: MobileStepbar.mobileStep__index,
            step_disabled: MobileStepbar.mobileStep_disabled
        },
        StepContentStyles: {
            content__icon: MobileStepbar.stepContent__icon,
            segment__header: MobileStepbar.stepContent__segmentHeader,
            segment__price: MobileStepbar.stepContent__segmentPrice,
            price__money: MobileStepbar.stepContent__priceMoney,
            footer: MobileStepbar.stepContent__footer
        }
    },
    MobileToolbar: {
        MobileToolbar: {
            wrapper: MobileToolbar.mobileTollbar,
            button: MobileToolbar.mobileTollbar__button,
            button_back: MobileToolbar.mobileTollbar__button_back
        }
    },
    PriceGraph: {
        PriceGraphStyles: {
            graphHeader: PriceGraph.graph__header
        }
    },
    Checkin: {
        Inital: {
            wrapper: Checkin.initial_wrapper,
            hint: Checkin.initial_hint,
            hint__image: Checkin.initial_hintImage,
            hint__info: Checkin.initial_hintInfo,
            hint__info__icon: Checkin.initial_hintInfoIcon,
            hint__info__text: Checkin.initial_hintInfoText
        },
        Passengers: {
            title: Checkin.passengers_title,
            passengers: Checkin.passengers_wrapper,
            segments: Checkin.passengers_segments,
            toolbar: Checkin.passengers_toolbar,
            toolbar__button: Checkin.passengers_button
        },
        Hint: {
            image: Checkin.hint_image
        }
    },
    RetrieveBooking: {
        RetrieveBooking: {
            container: Checkin.retrieveBooking_container,
            title: Checkin.retrieveBooking_title,
            form: Checkin.retrieveBooking_form,
            form__row: Checkin.retrieveBooking_row,
            checkout: Checkin.retrieveBooking_checkout
        }
    },
    Segment: {
        SegmentCommon: {
            wrapper: Checkin.segment_wrapper,
            header: Checkin.segment_header,
            header_withWeather: Checkin.segment_headerWeather,
            plane__icon: Checkin.segment_planeIcon,
            airline__name: Checkin.segment_airlineName,
            footer: Checkin.segment_footer,
            wrapper_business: Checkin.segment_wrapperBusiness
        }
    },
    AddPassenger: {
        AddPassenger: {
            wrapper: Checkin.addPassenger_wrapper,
            addButton: Checkin.addPassenger_addButton,
            form__wrapper: Checkin.addPassenger_formWrapper,
            form__input: Checkin.addPassengerForm_formInput,
            submitButton: Checkin.addPassengerForm_submitButton,
            input: Checkin.addPassengerForm_input,
            input_focused: Checkin.addPassengerForm_InputFocused
        }
    },
    RegisteredPassenger: {
        SendToEmail: {
            text: Checkin.sendToEmail__text
        },
        RegisteredPassenger: {
            header: Checkin.registeredPassenger_header,
            downloadButton: Checkin.passenger_downloadButton,
            downloadIcon: Checkin.passenger_downloadButtonIcon,
            actions: Checkin.registeredPassenger_actions
        }
    },
    ResendTicketsForm: {
        ResendTicketsForm: {
            input: Checkout.resendInput,
            loader: Checkin.resendTicket__loader,
            submit_button: Checkin.resendSubmit,
            resendTickets__form: ResendTicketsForm.resendTicketsForm_form,
            resendTickets__field: ResendTicketsForm.resendTicketsForm_field
        }
    },
    MobileSegment: {
        MobileSegment: {
            wrapper: Checkin.mobileSegment_wrapper,
            flightInfo__iatas: Checkin.mobileSegment_flightInfoIatas,
            planeIcon: Checkin.mobileSegment_planeIcon,
            flightInfo__cities: Checkin.mobileSegment_flightInfoCities,
            flightInfo__dates: Checkin.mobileSegment_flightInfoDates,
            flightInfo__time: Checkin.mobileSegment_flightInfoTime,
            fareGroup: Checkin.mobileSegment_fareGroup,
            fareGroup__info: Checkin.mobileSegment_fareGroupInfo,
            flightNumber: Checkin.mobileSegment_flightNumber,
            arrivalInfo__title: Checkin.mobile_arrivalInfoTitle,
            arrivalInfo__item: Checkin.mobile_arrivalInfoItem
        }
    },
    SelectedPassenger: {
        SelectedPassenger: {
            loyalty__link: Checkin.loyaltyLink,
            wrapper: Checkin.selectedPassenger_wrapper,
            passenger__name: Checkin.selectedPassenger_name,
            passengerInfo__item: Checkin.selectedPassenger_infoItem,
            passengerInfo__field: Checkin.selectedPassenger_infoField,
            rightSide: Checkin.selectedPassenger_rightSide
        }
    },
    CheckinRules: {
        CheckinRules: {
            rules__checkbox: Checkin.rules__checkbox,
            rules__checkbox_checked: Checkin.checkbox_checked,
            rules__button: Checkin.checkinRules_button
        }
    },
    Sidebar: {
        Sidebar: {
            sidebar: Account.sidebar__sidebar,
            title: Account.sidebar__title,
            sidebar__item: Account.sidebar__item,
            item__text: Account.item__text,
            sidebar__item_selected: Account.sidebar__itemSelected,
            icon: Account.sidebar__icon,
            link: Account.sidebar_link
        },
        MobileMenu: {
            wrapper: cn(Account.mobileMenu_wrapper, Account.mobileMenu__collapse),
            content: Account.mobileMenu_content,
            title: Account.mobileMenu_title,
            user__avatar: Account.mobileMenu_userAvatar,
            user__info: Account.mobileMenu_userInfo,
            user__info__email: Account.mobileMenu_userInfoEmail,
            menu__item: Account.mobileMenu_menuItem,
            menu__item_selected: Account.mobileMenu_menuItemSelected,
            icon: Account.mobileMenu_icon
        }
    },
    Traveller: {
        Traveller: {
            wrapper: Account.traveller__wrapper,
            header: Account.traveller__header,
            title__traveller: Account.traveller__titleTraveller,
            add: Account.traveller__add
        }
    },
    TravellerForm: {
        TravellerForm: {
            traveller__form: Account.travellerForm__travellerForm,
            row: Account.travellerForm__row,
            button__delete: Account.travellerForm__buttonDelete,
            row__reverse: Account.travellerForm__rowReverse,
            sex: Account.travellerForm__sex,
            loader: Account.travellerForm_loader,
            success: Account.travellerForm_loaderSuccess,
            select__input: Account.travellerForm_selectInput
        }
    },
    AccountModule: {
        Account: {
            warning: Account.warning,
            social__networks: Account.account_socialNetworks
        },
        InfoField: {
            input: Account.InfoField_input
        }
    },
    Account: {
        Account: {
            account__content: Account.account_content,
            social__networks: Account.account_socialNetworks,
            account__offers: Account.account_offers,
            checkbox: Account.account_checkbox,
            checked: Account.account_checkboxChecked
        },
        InfoField: {
            input: Account.InfoField_input
        }
    },
    LoginPage: {
        LoginForm: {
            social_wrapper: Account.social_wrapper,
            social_title: Account.social_wrapper
        },
        Form: {
            loginForm__button: Account.loginPage_button,
            social: Account.loginPage_social,
            social__text: Account.loginPage_socialText,
            social__buttons: Account.loginPage_socialButtons,
            alternative: Account.loginPage_alternative,
            footer: Account.loginForm__footer
        },
        Register: {
            actions: Account.register_actions,
            checkbox: Account.register_checkbox,
            checkbox_checked: Account.register_checkboxChecked
        },
        Verification: {
            LoginVerification__form: Account.verification_form,
            LoginVerification__input: Account.verification_input,
            submit_button: Account.verification_submitButton,
            loader: Account.verification_loader,
            success: Account.verification_loaderSuccess
        }
    },
    Timer: {
        Timer: {
            link: Account.timer_link
        }
    },
    DocumentForm: {
        DocumentForm: {
            select__input: Account.documentForm_selectInput,
            footer: Account.documentForm_footer
        }
    },
    InfoCard: {
        InfoCard: {
            card_dummy: Account.infoCard_cardDummy,
            footer: Account.infoCard_footer,
            subtitle: Account.infoCard_subtitle
        }
    },
    Refund: {
        StepsButtons: {
            button: Refund.stepButton,
            backButton: Refund.back
        },
        AddFile: {
            addIcon: Refund.addFileIcon
        },
        Ticket: {
            ticket: Refund.ticket,
            price: Refund.ticket__price,
            file: Refund.ticket__file,
            reject: Refund.ticket__reject
        },
        Wrapper: {
            header: Refund.wrapperHeader,
            close: Refund.wrapper__close
        },
        Breadcrumbs: {
            breadcrumb: Refund.breadcrumb
        },
        MobileStep: {
            header: Refund.mobileStepHeader
        },
        Refund: {
            prices: Refund.prices,
            stepTitle: Refund.stepTitle,
            reasons: Refund.refund_reasons,
            createTicket: Refund.refund_createTicket
        },
        StepTitle: {
            icon: Refund.stepIcon,
            text: Refund.stepText
        },
        RefundPaper: {
            paper: Refund.paper
        },
        Passenger: {
            passenger: Refund.passenger,
            label: Refund.passengerLabel,
            checkbox: Refund.passengerCheckbox,
            active: Refund.passenger_active
        },
        Reason: {
            label: Refund.reasonLabel,
            active: Refund.reasonLabel_active,
            radio: Refund.reasonRadio
        },
        RequestForm: {
            checkbox: Refund.requestCheckbox,
            active: Refund.requestCheckbox_active
        },
        Note: {
            text: Refund.note_text
        },
        ReasonForm: {
            reasons: ReasonForm.reasons,
            reason: ReasonForm.reason,
            groupTitle: ReasonForm.groupTitle
        }
    },
    Exchange: {
        Inner: {
            header: Exchange.header,
            header__inner: Exchange.header__inner,
            header__text: Exchange.header__text,
            exchange: Exchange.exchange,
            closeIcon: Exchange.close,
            container: Exchange.container
        },
        CommonSelect: {
            container: Exchange.common,
            header: Exchange.common__header,
            icon: Exchange.common__icon,
            button: Exchange.common__button,
            back: Exchange.common__back
        },
        Choice: {
            container: Exchange.choice,
            label: Exchange.choice__label,
            label_selected: Exchange.choice__label_selected,
            button: Exchange.choice__button,
            button_checked: Exchange.choice__button_checked
        },
        Chip: {
            chip: Exchange.chip,
            close: Exchange.chip__close
        },
        SearchFlights: {
            header: Exchange.searchFlights__header,
            leg: Exchange.searchFlights__leg,
            route: Exchange.searchFlights__route,
            footer: Exchange.searchFlights__footer,
            notices: Exchange.searchFlights__notices,
            notice_item: Exchange.searchFlights__noticeItem,
            flight__price: Exchange.searchFlights__flightPrice
        },
        Calendar: {
            calendar: Exchange.calendarButton,
            monthsWrapper__wrapper: Exchange.monthsWrapper__wrapper
        },
        SelectedFlights: {
            flight: Exchange.exchange__flight,
            header__name: Exchange.selectedFlights__headerName,
            change: Exchange.selectedFlights__change,
            charge: Exchange.selectedFlights__charge,
            charge__money: Exchange.selectedFlights__chargeMoney,
            money: Exchange.selectedFlights__money,
            total: Exchange.selectedFlights__total,
            total__money: Exchange.selectedFlights__totalMoney,
            price: Exchange.selectedFlights__price
        },
        CreateRequest: {
            submit: Exchange.createRequest__submit,
            button: Exchange.createRequest__checkbox,
            button_checked: Exchange.createRequest__checkbox_checked,
            controls: Exchange.createRequest__controls
        },
        Notice: {
            icon: Exchange.createRequest_noticeIcon
        },
        Sort: {
            title: Exchange.sort_title
        },
        RequestControls: {
            button: Exchange.requestControls_button
        },
        Datepicker: {
            wrapper: Exchange.datepicker__wrapper
        }
    },
    Modal: {
        Modal: {
            modal: Modal.modal,
            closeIcon: Modal.closeIcon,
            modal_rounded: Modal.rounded
        }
    },
    Warnings: {
        WarningsStyles: {
            wrapper: Account.warning__wrapper,
            warning__icon: Account.warning__warningIcon,
            warning__text: Account.warning__warningText
        }
    },
    BaggageCard: {
        BaggageCard: {
            title: BaggageCard.baggageCard__title,
            description: BaggageCard.baggageCard__description,
            button: cn(Baggage.button),
            button_edit: cn(Baggage.button_change)
        }
    },
    ScheduleForm: {
        Location: {
            input: ScheduleFormLocation.input
        },
        Value: {
            container: ScheduleFormValue.container,
            name: ScheduleFormValue.name,
            iata: ScheduleFormValue.iata
        }
    },
    CoreSchedule: {
        Location: {
            city: CoreScheduleLocation.city,
            country: CoreScheduleLocation.country
        },
        ScheduleFlight: {
            companyName: ScheduleFlight.companyName,
            point__dateContainer: ScheduleFlight.point__dateContainer,
            point__time: ScheduleFlight.point__time,
            routeArrow__route: ScheduleFlight.routeArrow__route,
            routeArrow__timeInRoute: ScheduleFlight.routeArrow__timeInRoute,
            totalDuration: ScheduleFlight.totalDuration,
            segment__routeInfo: ScheduleFlight.segment__routeInfo,
            amenities: ScheduleFlight.amenities,
            routeArrow__flightNumber: ScheduleFlight.routeArrow__flightNumber,
            routeArrow__stop: ScheduleFlight.routeArrow__stop
        },
        WeekDays: {
            container: WeekDays.container,
            active: WeekDays.active
        },
        DateSwitcher: {
            selector: DateSwitcher.selector,
            scrollBody: DateSwitcher.scrollBody,
            paper: DateSwitcher.paper
        },
        Weekpicker: {
            header__day: Weekpicker.header__day,
            months__wrapper: Weekpicker.months__wrapper,
            day__day: Weekpicker.day__day,
            day__today: Weekpicker.day__today,
            day__selected: Weekpicker.day__selected,
            day__start: Weekpicker.day__start,
            day__end: Weekpicker.day__end,
            day__inPeriod: Weekpicker.day__inPeriod,
            highlightDate: Weekpicker.highlightDate
        }
    },
    SpecialEquipment: {
        SpecialEquipment: {
            upgradeHeader: SpecialEquipment.upgradeHeader
        }
    },
    ResultsError: {
        ResultsError: {
            header: ResultsError.header,
            body: ResultsError.body
        }
    },
    Baggage: {
        BaggageIcon: {
            measurement: BaggageIcon.measurement
        }
    },
    AdditionalBaggage: {
        PromoMessage: {
            root: AdditionalBaggage.promoMessage__root
        }
    },
    UpgradeBaggageDialog: {
        BaggageDialogHeader: {
            categories: BaggageDialogHeader.categories,
            categories__item: BaggageDialogHeader.categories__item
        },
        BaggageSegment: {
            disabled: UpgradeBaggageDialog.baggageSegment_disabled,
            price: UpgradeBaggageDialog.baggageSegment_price,
            price__empty: UpgradeBaggageDialog.price__empty
        },
        BaggageFooter: {
            price_wrapper: Baggage.baggageFooter__priceWrapper,
            clear: Baggage.baggageFooter__clear,
            cancel_btn: cn(Baggage.button_cancel),
            confirm_btn: cn(Baggage.button_confirm)
        },
        UpgradeBaggageDialog: {
            modalHeader: UpgradeBaggageDialog.modalHeader
        }
    },
    PassengerForm: {
        Accompanying: {
            accompanying: Accompanying.accomplaing
        },
        Group: {
            title_disabled: Group.title_disabled
        },
        Disabilities: {
            checkboxes: Disabilities.checkboxes
        }
    },
    AddBooking: {
        AddBooking: {
            buttonContinue: AddBooking.buttonContinue
        }
    },
    TicketExample: {
        TicketExample: {
            ticketExample: TicketExample.ticketExample,
            ticketExample__leftSide: TicketExample.ticketExample__leftSide,
            ticketExample__rightSide: TicketExample.ticketExample__rightSide
        }
    },
    InsurancePopup: {
        InsurancePopup: {
            header: InsuranceService.insurancePopup__header
        }
    },
    AdditionalServices: {
        Insurance: {
            paper: InsuranceService.insurance_paper
        }
    },
    PaymentResult: {
        PaymentResult: {
            wrapper: PaymentResult.paymentResult__wrapper
        }
    },
    Money: {
        Money: {
            money: cn(UpgradeBaggageDialog.money)
        }
    },
    WarningModal: {
        WarningModal: {
            paper: Modal.warningModal__paper,
            content__text: Modal.warningModal__text
        }
    },
    AircraftPopup: {
        AircraftPopupContent: {
            schema: AircraftPopup.schema,
            image: AircraftPopup.image
        }
    },
    BaggageTotalPriceBlock: {
        BaggageTotalPriceBlock: {
            price: Baggage.totalPrice__price,
            control: cn(Baggage.button),
            control__edit: cn(Baggage.button_change)
        }
    },
    BaggageList: {
        BaggageList: {
            add: Baggage.baggageList__add
        }
    },
    InsurancePage: {
        InsurancePrice: {
            price: InsuranceService.insurancePrice__price
        },
        SelectForm: {
            form: InsuranceSelectForm.form,
            root: InsuranceSelectForm.root,
            label: InsuranceSelectForm.label
        },
        OptionsList: {
            list: cn(InsuranceOptionsList.list, InsuranceOptionsList.root)
        }
    }
};
export default theme;
